import Vapi from 'vuex-rest-api';

const fetcherAdminTag = new Vapi({
  state: {
    fetcherAdminTag: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminTag',
    property: 'fetcherAdminTag',
    path: ({ tid }) => `/api/fetcher/admin/tags/${tid}`,
  })
  .getStore();

export default fetcherAdminTag;
